module.exports = __webpack_public_path__ + "media/images/icons/pin-eac9a0b88948a9eb65cb2e96de861151.svg";